<template>
    <div>
        <b-modal id="taxis-modal" title="Επικύρωση στοιχείων" cancel-title="Κλείσιμο" ok-title="Ατομικά στοιχεία"
                 ok-variant="warning"
                 @ok="checkTaxis">
            <TaxisCheckComponent></TaxisCheckComponent>
        </b-modal>
        <b-alert v-if="this.$store.getters.userRole === 'ROLE_USER'" show>
          {{ this.alertMessage }}
        </b-alert>
        <h1 class="display-5">{{ this.title }}</h1>

        <div v-if="show_validate_efedros" aria-live="polite" aria-atomic="true" style="position: relative;">
            <div class="toastefedros"
                 style="position: absolute; top: 150px; right: 0; background-color: #BEBEBE; min-width: 25%;">
                <div class="toast-header">
                    <strong class="mr-auto">Έγκριση Εφέδρων</strong>
                    <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="toast-body">
                    {{ message_toast }}
                </div>
            </div>
        </div>

        <br>
        <div>
            <b-img fluid class="image" alt="HellenicArmySeals logo" v-bind:src="'/files/HellenicArmySeal.png'" style="max-height: 600px"></b-img>
        </div>

    </div>
</template>

<script>
import TaxisCheckComponent from "@/components/TaxisCheckComponent";

export default {
    name: "UserDashboard",

    data() {
        return {
          show_validate_efedros: false,
          message_toast: "",
          statsData: [],
          title: "Ηλεκτρονική Εφαρμογή Αποστολής Ειδοποίησης Εφέδρου",
          alertMessage: "Παρακαλούμε αποθηκεύστε/εκτυπώστε το Ειδικό Φύλλο Πορείας (Ε.Φ.Π.) πατώντας την επιλογή \"Εκτύπωση Ειδικού Φύλλου Πορείας\"" +
                        "που βρίσκεται στο μενού.\n Παρακαλούμε επικυρώστε τα στοιχεία πατώντας την επιλογή \"Ατομικά στοιχεία\" που βρίσκεται στο μενού."
        }
    },
    components: {
        TaxisCheckComponent,
        // Statistics
    },

    computed: {
    },
    mounted() {
        if (!this.$store.getters.isLoggedIn) {
            this.$router.push('login', () => {
            });
            return;
        }

        this.$store.dispatch("loading")
        this.$store.dispatch("getUserInfo").then( () => {
            if (this.$store.getters.userRole === "ROLE_MANAGER" || this.$store.getters.userRole === "ROLE_SXHMATISMOS") {
                this.$store.dispatch('loading');
                this.$store.dispatch('stop_loading');
            } else if (this.$store.getters.userRole ==='ROLE_ADMIN' || this.$store.getters.userRole === 'ROLE_SUPERADMIN') {
                this.$store.dispatch('getStats').then(res => {
                    this.$store.dispatch("stop_loading")
                    this.statsData = res.data
                }).catch(() => {
                    this.$store.dispatch("stop_loading")
                })
            } else if (this.$store.getters.userRole === "ROLE_USER"){
                //if (!res.taxisAddrVerified && !this.$store.getters.isTaxisChecked) {
                //    this.$bvModal.show("taxis-modal")
                //}
                this.$store.dispatch("stop_loading")
            }
            if (this.$store.getters.userRole === "ROLE_MANAGER" || this.$store.getters.userRole === "ROLE_SXHMATISMOS") {
                this.$store.dispatch("stop_loading")
            }

        }).catch(() => {
            this.$store.dispatch('stop_loading');
        });

    },
    methods: {

        checkTaxis() {
            this.$store.commit("setTaxisChecked", true);
            this.$router.push('user-details');
        }
    }
}
</script>

<style scoped>

</style>